import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import './util/interceptor';


// axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.baseURL = window._env_?.API_BASE_URL || 'https://trader-pro-dev.onrender.com/';

axios.defaults.timeout = 30000;
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
 // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
